import type {
  CarePlan,
  CarePlanAdl,
  Carer,
  Log,
  Resident
} from '@lmc/ts-common'
import _ from 'lodash'
import type React from 'react'
import CarePlanSummaryHeader from '../../../../../../components/carePlans/CarePlanSummaryHeader'
import styles from '../../CarePlanReiviewForm.styles'

type SetFormField = {
  key: string
  value: string | number | string[] | boolean
}

// @ts-ignore
export interface ICarePlanForm extends CarePlan {
  carePlanAdl?: CarePlanAdl
}

interface ICarePlanReviewHeader {
  carers: Carer[]
  errors: string[]
  signatureLogs?: Log[]
  setFormField: (update: SetFormField) => void
  carePlanNominative: string
  handleCancel: () => void
  onClickHistory: () => void
  resident: Resident
  fields: ICarePlanForm
  FORM_ID: string
}

export const CarePlanReviewHeader = ({
  carers,
  errors,
  signatureLogs,
  setFormField,
  carePlanNominative,
  handleCancel,
  onClickHistory,
  resident,
  fields,
  FORM_ID
}: ICarePlanReviewHeader): React.ReactElement => {
  const editedBy = _.find(carers, { id: fields.editedBy })
  return (
    <div style={styles.headerContainer}>
      <CarePlanSummaryHeader
        carePlan={fields as any}
        carer={editedBy}
        errors={errors}
        fields={fields}
        logs={signatureLogs}
        setFormField={setFormField}
        formId={FORM_ID}
        onClickBack={handleCancel}
        onClickHistory={onClickHistory}
        isInitialAssessment={false}
        resident={resident}
        carePlanNominative={carePlanNominative}
        titleContainerStyle={{ marginBottom: 24 }}
      />
    </div>
  )
}

export default CarePlanReviewHeader
